"use client";

import { useEffect } from "react";

export function SuppressThreeWarnings() {
  useEffect(() => {
    const originalWarn = console.warn;
    console.warn = function (...args: any[]) {
      // Suppress THREE.Clock deprecation warning
      if (
        args[0] &&
        typeof args[0] === "string" &&
        args[0].includes("THREE.Clock") &&
        args[0].includes("deprecated")
      ) {
        return;
      }
      originalWarn.apply(console, args);
    };

    return () => {
      console.warn = originalWarn;
    };
  }, []);

  return null;
}
